import React from 'react';
import { Card, Link } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styles from '../Configurator.module.less';
import useGetLoginUrl from '../../../util/useGetLoginUrl';

const CardConfigurator = ({ content }) => {
  const isUserLoggedIn = useSelector((state) => state?.app?.prunedUser?.isUserLoggedIn);
  const loginUrl = useGetLoginUrl();

  if (!isUserLoggedIn) {
    return (
      <div className={styles.card_container}>
        <Card>
          <div className={styles.card_header}>{content.title}</div>
          <Card.Content>{content.login_text}</Card.Content>
          <div>
            <Link href={loginUrl}>{content.link_text}</Link>
          </div>
        </Card>
      </div>
    );
  }
  return null;
};

CardConfigurator.propTypes = { content: PropTypes.object.isRequired };
export default CardConfigurator;
